"use client";

/**
 * Provider component for MediaFactory.
 */
export function MediaFactoryProvider({ children }: { children: React.ReactNode }) {
  return <>{children}</>;
}
